import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useCV } from '../../../../contexts/CVContext'
import styles from './WeeklyShortlist.module.css'
import LeftSidebar from './components/LeftSidebar'
import ShortlistContent from './components/ShortlistContent'
import ActionsPage from '../../ActionsPage/ActionsPage'
import UploadModal from '../../uploadModal/UploadModal'

const WeeklyShortlist = () => {
    const [activeTab, setActiveTab] = useState('shortlist')
    const { isCVUploaded } = useCV()
    const navigate = useNavigate()

    useEffect(() => {
        if (!isCVUploaded && window.innerWidth <= 768) {
            navigate('/dashboard/upload')
        }
    }, [isCVUploaded, navigate])

    const [showUploadModal, setShowUploadModal] = useState(!isCVUploaded && window.innerWidth > 768);

    useEffect(() => {
        setShowUploadModal(!isCVUploaded && window.innerWidth > 768);
    }, [isCVUploaded]);

    return (
        <div className={styles.container}>
            <LeftSidebar activeTab={activeTab} setActiveTab={setActiveTab} />
            <div className={styles.mainContent}>
                {activeTab === 'shortlist' ? <ShortlistContent /> : <ActionsPage />}
            </div>
            {showUploadModal && (
                <UploadModal 
                  isModal={true} 
                  onClose={() => setShowUploadModal(false)} 
                />
            )}
        </div>
    )
}

export default WeeklyShortlist
